const initialState = {
  usersAtFieldLevel: {
    items: [],
    isLoading: false,
    selectedFieldList: [],
  },
  isPageLoading: false,
  vendorOptions: {
    items: [],
    isLoading: false,
  },
  certificatesOptions: {
    items: [],
    isLoading: false,
  },
  skillLevelOptions: {
    items: [],
    isLoading: false,
  },
  aclQualifiedOptions: {
    items: [],
    isLoading: false,
  },
  bulkUploadUsers: {
    correctUsers: [],
    incorrectUsers: [],
    isLoading: false,
  },
  userInfoAfterEdit: {
    user: [],
  },
  userEditInfo: {
    user: {},
    isLoading: false,
    returnToPage: {
      TaskViewPage: false,
      TaskEditPage: '',
    },
  },
  gridParam: { startRow: 0, endRow: 10 },
  teamViewListOptions: {
    items: [],
    isLoading: true,
  },
  isExporting: false,
};

export default initialState;
